// extracted by mini-css-extract-plugin
module.exports = {"main":"FaqHubTemplate_main__xAt_f","list":"FaqHubTemplate_list__Oz2wY","rotation":"FaqHubTemplate_rotation___hr0L"};